import angular from 'angular';
import secureFileUploaderComponent from './secureFileUploader.component';
import secureFileUploaderService from './secureFileUploader.service';

let secureFileUploaderModule = angular.module('secureFileUploader', [])
  .component('secureFileUploader', secureFileUploaderComponent)
  .service('secureFileUploaderService', secureFileUploaderService);

export default secureFileUploaderModule;



// WEBPACK FOOTER //
// ./app/components/secureFileUploader/secureFileUploader.js